import { DISCOUNT_RATES } from '@/constants';

interface DiscountRateGuideProps {
  type: 'deadline' | 'reservation';
}

export function DiscountRateGuide({ type }: DiscountRateGuideProps) {
  const getGuideContent = () => {
    if (type === 'deadline') {
      return {
        title: '마감할인 설정 안내',
        rules: [
          `개별 상품: 최소 ${DISCOUNT_RATES.DEADLINE_MINIMUM}% 이상 할인`,
          `랜덤세트: 최소 ${DISCOUNT_RATES.RANDOM_SET_MINIMUM}% 이상 할인`,
          '할인 상품은 당일 픽업만 가능합니다',
          '수락 전까지 고객이 취소할 수 있으니 빠른 확인을 권장합니다'
        ]
      };
    } else {
      return {
        title: '예약할인 설정 안내',
        rules: [
          `할인율: 0% ~ ${DISCOUNT_RATES.RESERVATION_MAXIMUM}% (판매자 선택)`,
          '전날 예약 → 익일 픽업',
          '픽업 2시간 전까지 취소 가능합니다',
          '수량은 제한 없이 설정 가능합니다'
        ]
      };
    }
  };

  const { title, rules } = getGuideContent();

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <svg 
          className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
        <div className="text-sm text-blue-700">
          <p className="font-medium mb-1">{title}</p>
          <ul className="space-y-1 text-sm">
            {rules.map((rule, index) => (
              <li key={index}>• {rule}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
